import type { GtmConfigurationDictionary } from '@libs/analytics';
import { gtmConfigurationDictionary } from '@libs/analytics';
import Script from 'next/script';

export function GTMScript() {
    const locale = process.env.NEXT_PUBLIC_LOCALE ?? 'en-US';

    const { gtmAuth, gtmPreview, gtmContainerId } =
        gtmConfigurationDictionary[locale as keyof GtmConfigurationDictionary];

    return (
        <Script
            id="gtm-script"
            dangerouslySetInnerHTML={{
                __html: `
(function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),
    dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.onload = function() {
        console.log('GTM Loaded at', Date.now());
        w[l].push({event: 'loaded-gtm'})
    }
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x';
    f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmContainerId}');
                    `,
            }}
        />
    );
}
